import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type=number]',
})
export class NumberInputDirective {
  readonly allowedKeys = new Set<string>([
    'Tab',
    'Home',
    'End',
    'Delete',
    'Backspace',
    'Enter',
    'ArrowUp',
    'ArrowRight',
    'ArrowDown',
    'ArrowLeft',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    ',',
  ]);

  @HostListener('keydown', ['$event'])
  onInputChange(event: KeyboardEvent): void {
    if (event.ctrlKey || event.altKey) {
      return;
    }

    // only allow numeric keys, backspace, dot, or comma
    if (this.allowedKeys.has(event.key)) {
      return;
    }

    event.preventDefault();
  }
}
